import {parseNumberWithCommaDecimal} from "./stringUtil";
import {VariablesConstant} from "../constants/variables";
import dayjs from "dayjs";

export class GridUtil {
  public static numberFormatter(e: any, decimalPoint?: number, isAbs: boolean = false) {
    if (e?.value && !isNaN(e.value)) {
      let value = e.value;
      if (decimalPoint) {
        const s = Math.pow(10, decimalPoint);
        value = Math.round( e.value * s) / s;
      }
      return parseNumberWithCommaDecimal(isAbs ? Math.abs(value) : value);
    } else {
      return '-';
    }
  }

  public static  dateToStringFormatterAuto(e: any) {
    let toDateFormat = 'YYYY-MM-DD';
    let fromDateFormat = 'YYYYMMDD';

    if (e?.value) {
      if (e.value.length === 19 && e.value.includes('T')) {
        return dayjs(e.value).format('YYYY년 M월 D일 H시 m분');
      } else if (e.value.length === 14) {
        fromDateFormat = 'YYYYMMDDHHmmss';
        toDateFormat = 'YYYY년 M월 D일 H시 m분 s초';
      } else if (e.value.length === 12) {
        fromDateFormat = 'YYYYMMDDHHmm';
        toDateFormat = 'YYYY년 M월 D일 H시 m분';
      } else if (e.value.length === 10) {
        fromDateFormat = 'YYYYMMDDHH';
        toDateFormat = 'YYYY년 M월 D일 H시';
      } else if (e.value.length === 8) {
        fromDateFormat = 'YYYYMMDD';
        toDateFormat = 'YYYY년 M월 D일';
      } else if (e.value.length === 6) {
        fromDateFormat = 'YYYYMM';
        toDateFormat = 'YYYY년 M월';
      } else if (e.value.length === 4) {
        fromDateFormat = 'YYYY';
        toDateFormat = 'YYYY년';
      }
    }
    return GridUtil.dateToStringFormatter(e, toDateFormat, fromDateFormat);
  }

  public static dateToStringLastFormatterAuto(e: any) {
    let toDateFormat = 'D일';
    let fromDateFormat = 'YYYYMMDD';

    if (e?.value) {
      if (e.value.length === 19 && e.value.includes('T')) {
        return dayjs(e.value).format('m분');
      } else if (e.value.length === 12) {
        fromDateFormat = 'YYYYMMDDHHmm';
        toDateFormat = 'm분';
      } else if (e.value.length === 10) {
        fromDateFormat = 'YYYYMMDDHH';
        toDateFormat = 'H시';
      } else if (e.value.length === 8) {
        fromDateFormat = 'YYYYMMDD';
        toDateFormat = 'D일';
      } else if (e.value.length === 6) {
        fromDateFormat = 'YYYYMM';
        toDateFormat = 'M월';
      } else if (e.value.length === 4) {
        fromDateFormat = 'YYYY';
        toDateFormat = 'YYYY년';
      }
    }
    return GridUtil.dateToStringFormatter(e, toDateFormat, fromDateFormat);
  }

  public static dateToStringFormatter(e: any, toFormat: string = 'YYYY-MM-DD', fromFormat: string = 'YYYYMMDD') {
    if (e?.value !== null && e?.value !== undefined && e?.value !== '') {
      return dayjs(e.value, fromFormat).format(toFormat);
    } else {
      return '';
    }
  }

  public static gridComplex(e:any) {
    const option = VariablesConstant.INDS_CMPLX_OPTIONS.find(data=>data.value === e.value );
    return option ? option.label : "";
  }

  public static handleRadioByRowClick(event: any) {
    event.instance.uncheckAll();
    event.instance.check(event.rowKey);
  }

  public static ifNullReturnDash(e: any) {
    if (e?.value === null || e?.value === undefined) {
      return '-';
    }
    return e.value;
  }
}